
import { Module } from 'lib/vendor/terrific/Module';
import { Hook, Sandbox } from 'lib/vendor/terrific/Sandbox';
import deparam from 'lib/vendor/jquery-deparam-patched';

const KEY_FORM = 'FORM_DATA_RESTORE';
const TYPE_RESTORE = 'restore';
const TYPE_STORE = 'store';
const TYPE_STORE_RESTORE = 'storeRestore';
/**
 * Form Data Restore Module
 */
export default class FormDataRestore extends Module {

	private readonly dataIncludes : string[];
	private readonly storeType : string;


	constructor($ctx : JQuery, sandbox : Sandbox, id : number, modName : string) {

		super($ctx, sandbox, id, modName);
		this.storeType = $ctx.data('store-type') || '';

		const formData = $ctx.data('form-data-includes') || '';
		this.dataIncludes = formData.split(',');

	}

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {

		const form = this.$ctx.find('form');
		if(form.length === 0) {
			callback();

			return;
		}

		const formElement = form.get(0) as HTMLFormElement;
		const elements = formElement.elements as unknown as Record<string, HTMLInputElement>;

		if(this.storeType === TYPE_RESTORE || this.storeType === TYPE_STORE_RESTORE) {
			const formData = sessionStorage.getItem(KEY_FORM);
			if (formData) {
				const data = deparam(formData);

				for (const key in data) {
					if (this.dataIncludes.includes(key)) {
						const element = elements[key];
						if (element) {
							element.value = data[key];
						}
					}
				}
			}
		}

		if(this.storeType === TYPE_STORE || this.storeType === TYPE_STORE_RESTORE) {
			form.on('submit', () => {
				const filteredData : Record<string, string> = {};
				this.dataIncludes.map(key => filteredData[key] = elements[key].value);

				if(this.storeType === TYPE_STORE_RESTORE) {
					const formData = sessionStorage.getItem(KEY_FORM);
					if (formData) {
						const data = deparam(formData);

						for (const key in data) {
							if (!filteredData[key]) {
								filteredData[key] = data[key];
							}
						}
					}
				}
				sessionStorage.setItem(KEY_FORM, $.param(filteredData));
			});
		}

		callback();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/form/Tc.Module.FormDataRestore.ts